<div
  [ngClass]="{ 'lg:flex': !mobileView }"
  class="w-full bg-white justify-center items-center"
  #categoriesWrapper
>
  <p class="text-md lg:1xsl pt-5 lg:pt-2 lg:mr-2.5 font-accent font-bold text-center lg:text-left">
    {{ title }}
  </p>
  @if (!hidePrevBtn) {
    <p class="hidden lg:block lg:ml-9.5">
      <app-rounded-icon-button
        icon="icon-arrow-left"
        color="primary"
        [outlined]="true"
        [disabled]="itemsScrolled === itemsPerPage"
        (onClick)="prevPage()"
      ></app-rounded-icon-button>
    </p>
  }
  @if (items) {
    <ul
      [style.width.px]="slideWidth"
      [ngClass]="{ 'lg:overflow-x-hidden lg:my-7': !mobileView }"
      class="flex overflow-x-auto flex-shrink-0 my-3 mx-4 scrollbar-hide"
    >
      @for (item of items; track item; let index = $index) {
        <li
          [ngClass]="{ 'lg:w-20': !mobileView }"
          class="w-16.5 text-center flex-shrink-0 px-1 mt-1 cursor-pointer"
          [id]="'slide_' + (index + 1)"
          (click)="clickCard.emit(item)"
        >
          @if (item.icon_url) {
            <img
              src="{{ item.icon_url }}"
              alt="{{ item.name }}"
              class="max-w-48px mx-auto"
            />
          }
          <p
            [ngClass]="{ 'lg:text-sm': !mobileView }"
            class="mt-3 text-xs font-accent font-bold break-all"
          >
            {{ item.name }}
          </p>
        </li>
      }
    </ul>
  } @else {
    <ul
      [style.width.px]="slideWidth"
      class="lg:overflow-x-hidden flex overflow-x-auto flex-shrink-0 my-3 mx-4 scrollbar-hide"
    >
      @for (j of [].constructor(4); track $index) {
        <li class="w-16 mr-2 lg:w-20 text-center flex-shrink-0 px-1 mt-1">
          <div class="w-full h-12 mb-2 animate-pulse bg-neutral-50"></div>
          <div class="h-1.5 w-full animate-pulse bg-neutral-100"></div>
        </li>
      }
    </ul>
  }

  @if (!hideNextBtn) {
    <p class="hidden lg:block">
      <app-rounded-icon-button
        icon="icon-arrow-right"
        color="primary"
        [disabled]="itemsScrolled === items?.length"
        [outlined]="true"
        (onClick)="nextPage()"
      ></app-rounded-icon-button>
    </p>
  }
</div>
